module.exports = __webpack_public_path__ + "static/img/wealth_level_56.5cd9fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_56.png
// module id = CVh7
// module chunks = 0